// @ts-nocheck

import { reduce, size } from 'lodash';

import basketItemSetBoomActive from '../../../modules/boom/reducers/basket/handlers/basketItemSetBoomActive';
import basketResetBoomActives from '../../../modules/boom/reducers/basket/handlers/basketResetBoomActives';
import basketSetBoomActive from '../../../modules/boom/reducers/basket/handlers/basketSetBoomActive';
import basketItemSetIsGRActive from '../../../modules/gift-race/reducers/basket/handlers/basketItemSetIsGRActive';
import basketSetIsGRActive from '../../../modules/gift-race/reducers/basket/handlers/basketSetIsGRActive';
import resetAllGRActives from '../../../modules/gift-race/reducers/basket/handlers/resetAllGRActives';
import basketItemSetKLEligibleCollectible from '../../../modules/koh-lanta/reducers/basket/handlers/basketItemSetKLEligibleCollectible';
import basketSetKLEligibleCollectible from '../../../modules/koh-lanta/reducers/basket/handlers/basketSetKLEligibleCollectible';
import resetKLEligibleCollectibles from '../../../modules/koh-lanta/reducers/basket/handlers/resetKLEligibleCollectibles';
import basketDelMPCard from '../../../modules/monopoly/reducers/basket/basketDelMPCard';
import basketItemDelMPCard from '../../../modules/monopoly/reducers/basket/basketItemDelMPCard';
import basketItemSetIsMPActive from '../../../modules/monopoly/reducers/basket/basketItemSetIsMPActive';
import basketItemSetMPCard from '../../../modules/monopoly/reducers/basket/basketItemSetMPCard';
import basketSetIsMPActive from '../../../modules/monopoly/reducers/basket/basketSetIsMPActive';
import basketSetMPCard from '../../../modules/monopoly/reducers/basket/basketSetMPCard';
import resetAllMPActives from '../../../modules/monopoly/reducers/basket/resetAllMPActives';
import { BasketActionTypes } from '../../../types/actions/basket';
import { BetBuilderActionTypes } from '../../../types/actions/betbuilder';
import { MyMatchActionTypes } from '../../../types/actions/mymatch';
import { BasketModes, BasketStatuses } from '../../../types/basket';
import { BetslipTypes } from '../../../types/history';

import basketAcceptChanges from './basketAcceptChanges';
import basketAddBetbuilderItem from './basketAddBetbuilderItem';
import basketAddItem from './basketAddItem';
import basketAlterCachedMMAPIResponseInfos from './basketAlterCachedMMAPIResponseInfos';
import basketClear from './basketClear';
import basketClearValidatedAndWaiting from './basketClearValidatedAndWaiting';
import basketDelBonus from './basketDelBonus';
import basketDelFreebet from './basketDelFreebet';
import basketDelItem from './basketDelItem';
import basketGetSelection from './basketGetSelection';
import basketInjectTopMyMatch from './basketInjectTopMyMatch';
import basketItemBankerChange from './basketItemBankerChange';
import basketItemSelectedBonusChange from './basketItemSelectedBonusChange';
import basketItemSelectedFreebetChange from './basketItemSetFreebetBoolean';
import basketItemSetFreebetBoolean from './basketItemSetFreebetBoolean';
import basketItemStakeChange from './basketItemStakeChange';
import basketMyMatchMerge from './basketMyMatchMerge';
import basketReceiveBonuses from './basketReceiveBonuses';
import basketReceiveBoosters from './basketReceiveBoosters';
import basketReceiveFreebets from './basketReceiveFreebets';
import basketRefresh from './basketRefresh';
import basketRemoveCachedMMAPIResponseInfos from './basketRemoveCachedMMAPIResponseInfos';
import basketRemoveMultichoiceBetSelection from './basketRemoveMultichoiceBetSelection';
import basketReset from './basketReset';
import basketSanitize from './basketSanitize';
import basketSelectedBonusChange from './basketSelectedBonusChange';
import basketSetCashout from './basketSetCashout';
import basketSetDefaultStake from './basketSetDefaultStake';
import basketSetEligibleBonuses from './basketSetEligibleBonuses';
import basketSetEligibleBooster from './basketSetEligibleBooster';
import basketSetEligibleFreebets from './basketSetEligibleFreebets';
import basketSelectedFreebetChange from './basketSetFreebetBoolean';
import basketSetFreebetBoolean from './basketSetFreebetBoolean';
import basketSetItemEligibleBonuses from './basketSetItemEligibleBonuses';
import basketSetItemEligibleFreebets from './basketSetItemEligibleFreebets';
import basketSetItemStatusError from './basketSetItemStatusError';
import basketSetItemStatusOk from './basketSetItemStatusOk';
import basketSetItemStatusWaiting from './basketSetItemStatusWaiting';
import basketSetKeyboard from './basketSetKeyboard';
import basketSetLoadingOk from './basketSetLoadingOk';
import basketSetNotification from './basketSetNotification';
import basketSetSelection from './basketSetSelection';
import basketSetStatusError from './basketSetStatusError';
import basketSetStatusOk from './basketSetStatusOk';
import basketSetStatusPending from './basketSetStatusPending';
import basketSetStatusWaiting from './basketSetStatusWaiting';
import basketSplitMyMatch from './basketSplitMyMatch';
import basketStakeChange from './basketStakeChange';
import basketSubmit from './basketSubmit';
import basketSwitchMode from './basketSwitchMode';
import basketSystemItemSelectionChange from './basketSystemItemSelectionChange';
import basketSystemItemSelectionReset from './basketSystemItemSelectionReset';
import basketUpdateBetbuilderOdd from './basketUpdateBetbuilderOdd';
import basketUpdateItemIsFromMultichoice from './basketUpdateItemIsFromMultichoice';
import basketUpdateItemValue from './basketUpdateItemValue';
import basketValidateItems from './basketValidateItems';
import recomputeNextGRBasketState from './recomputeNextGRBasketState';
import recomputeNextMPBasketState from './recomputeNextMPBasketState';

// None actions are reduced while the basket is loading
const loadingSafetyDecorator = (reducer) => (state, action, extra) => {
  if (!state.loading) {
    return reducer(state, action, extra);
  }
  return state;
};

// None actions are reduced while the basket is pending
const dontTouchWhilePending = (reducer) => (state, action, extra) => {
  // Does NOT reduce the actions listed below if the status is pending
  if (
    !(
      state.status === BasketStatuses.PENDING &&
      [
        BasketActionTypes.SET_CASHOUT,
        BasketActionTypes.RESET,
        BetBuilderActionTypes.BASKET_UPDATE_BETBUILDER_ODD,
      ].indexOf(action.type) !== -1
    )
  ) {
    return reducer(state, action, extra);
  }
  return state;
};

// Keep betslip mode safe in cashout mode
const keepBetslipModeSafe = (handler) => (state, action, extra) => {
  const { isCashout, cashoutBetslipType } = state;
  const returnValue = handler(state, action, extra);
  if (isCashout) {
    if (cashoutBetslipType === BetslipTypes.MULTIPLE || cashoutBetslipType === BetslipTypes.SINGLE) {
      if (returnValue.mode !== BasketModes.COMBINED) {
        if (size(returnValue.items) > 1) {
          return state;
        }
      }
    }
  }
  return returnValue;
};

// Cannot delete / edit a cashout item in cashout mode
const cannotTouchACashoutItem = (handler) => (state, action, extra) => {
  const { isCashout, items } = state;
  if (isCashout) {
    if (
      [
        BasketActionTypes.DEL_ITEM,
        BasketActionTypes.ITEM_BANKER_CHANGE,
        BasketActionTypes.ITEM_STAKE_CHANGE,
        BasketActionTypes.ITEM_SELECTED_FREEBET_CHANGE,
        BasketActionTypes.SET_ITEM_ELIGIBLE_FREEBETS,
        BasketActionTypes.SYSTEM_ITEM_SELECTION_CHANGE,
        BasketActionTypes.SYSTEM_ITEM_SELECTION_RESET,
      ].indexOf(action.type) !== -1
    ) {
      const item = items[action.payload.oddId];
      if (item.cashout) {
        return state;
      }
    }
  }
  return handler(state, action, extra);
};

// Cannot change stake in cashout mode
const cannotTouchBetslip = (handler) => (state, action, extra) => {
  const { isCashout } = state;
  if (isCashout) {
    if (
      [
        BasketActionTypes.STAKE_CHANGE,
        BasketActionTypes.SET_SELECTION,
        BasketActionTypes.GET_SELECTION,
        BasketActionTypes.SET_ELIGIBLE_FREEBETS,
        BasketActionTypes.SELECTED_FREEBET_CHANGE,
        BasketActionTypes.DEL_FREEBET,
      ].indexOf(action.type) !== -1
    ) {
      return state;
    }
  }
  return handler(state, action, extra);
};

// Remove cashout property when not active
const removeCashoutProperties = (handler) => (state, action, extra) => {
  const { isCashout } = state;
  const returnValue = handler(state, action, extra);
  if (isCashout !== returnValue.isCashout && !returnValue.isCashout) {
    return {
      ...returnValue,
      cashoutBetslipId: undefined,
      cashoutBetslipType: undefined,
    };
  }
  return returnValue;
};

const safeHandlers = {
  [BasketActionTypes.SET_LOADING_OK]: basketSetLoadingOk,
  [BasketActionTypes.RECEIVE_BOOSTERS]: basketReceiveBoosters,
  [BasketActionTypes.RECEIVE_FREEBETS]: basketReceiveFreebets,
  [BasketActionTypes.RECEIVE_BONUSES]: basketReceiveBonuses,
  [BasketActionTypes.SET_DEFAULT_BOOSTER_FROM_LICENCE]: basketReceiveBoosters,
  [BasketActionTypes.SET_DEFAULT_STAKE]: basketSetDefaultStake,
  [BasketActionTypes.SET_KEYBOARD]: basketSetKeyboard,
  [BasketActionTypes.ALTER_CACHED_MM_API_RESPONSE_INFOS]: basketAlterCachedMMAPIResponseInfos,
  [BasketActionTypes.REMOVE_CACHED_MM_API_RESPONSE_INFOS]: basketRemoveCachedMMAPIResponseInfos,
};

const unSafeHandlers = {
  // BASKET GLOBAL HANDLERS
  [BasketActionTypes.ACCEPT_CHANGES]: basketAcceptChanges,
  [BasketActionTypes.CLEAR]: basketClear,
  [BasketActionTypes.SET_STATUS_ERROR]: basketSetStatusError,
  [BasketActionTypes.SET_STATUS_OK]: basketSetStatusOk,
  [BasketActionTypes.SET_STATUS_PENDING]: basketSetStatusPending,
  [BasketActionTypes.SET_STATUS_WAITING]: basketSetStatusWaiting,
  [BasketActionTypes.REFRESH]: basketRefresh,
  [BasketActionTypes.RESET]: basketReset,
  [BasketActionTypes.STAKE_CHANGE]: basketStakeChange,
  [BasketActionTypes.SUBMIT]: basketSubmit,
  [BasketActionTypes.SET_SELECTION]: basketSetSelection,
  [BasketActionTypes.GET_SELECTION]: basketGetSelection,
  [BasketActionTypes.SWITCH_MODE]: basketSwitchMode,
  [BasketActionTypes.SET_ELIGIBLE_FREEBETS]: basketSetEligibleFreebets,
  [BasketActionTypes.SET_ELIGIBLE_BOOSTER]: basketSetEligibleBooster,
  [BasketActionTypes.SET_ELIGIBLE_BONUSES]: basketSetEligibleBonuses,
  [BasketActionTypes.SELECTED_FREEBET_CHANGE]: basketSelectedFreebetChange,
  [BasketActionTypes.SELECTED_BONUS_CHANGE]: basketSelectedBonusChange,
  [BasketActionTypes.DEL_FREEBET]: basketDelFreebet,
  [BasketActionTypes.DEL_BONUS]: basketDelBonus,
  [BasketActionTypes.CLEAR_VALIDATED_AND_WAITING]: basketClearValidatedAndWaiting,
  [BasketActionTypes.SET_NOTIFICATION]: basketSetNotification,
  [BasketActionTypes.SET_CASHOUT]: basketSetCashout,
  [BasketActionTypes.SET_FREEBET_BOOLEAN]: basketSetFreebetBoolean,

  // BASKET ITEM HANDLERS
  [BasketActionTypes.ADD_ITEM]: basketAddItem,
  [BasketActionTypes.ADD_BETBUILDER_ITEM]: basketAddBetbuilderItem,
  [BasketActionTypes.DEL_ITEM]: basketDelItem,
  [BasketActionTypes.ITEM_BANKER_CHANGE]: basketItemBankerChange,
  [BasketActionTypes.ITEM_STAKE_CHANGE]: basketItemStakeChange,
  [BasketActionTypes.ITEM_SELECTED_FREEBET_CHANGE]: basketItemSelectedFreebetChange,
  [BasketActionTypes.ITEM_SELECTED_BONUS_CHANGE]: basketItemSelectedBonusChange,
  [BasketActionTypes.SET_ITEM_ELIGIBLE_FREEBETS]: basketSetItemEligibleFreebets,
  [BasketActionTypes.SET_ITEM_ELIGIBLE_BONUSES]: basketSetItemEligibleBonuses,
  [BasketActionTypes.SET_ITEM_STATUS_ERROR]: basketSetItemStatusError,
  [BasketActionTypes.SET_ITEM_STATUS_OK]: basketSetItemStatusOk,
  [BasketActionTypes.SET_ITEM_STATUS_WAITING]: basketSetItemStatusWaiting,
  [BasketActionTypes.SYSTEM_ITEM_SELECTION_CHANGE]: basketSystemItemSelectionChange,
  [BasketActionTypes.SYSTEM_ITEM_SELECTION_RESET]: basketSystemItemSelectionReset,
  [BasketActionTypes.VALIDATE_ITEMS]: basketValidateItems,
  [BasketActionTypes.SET_ITEM_FREEBET_BOOLEAN]: basketItemSetFreebetBoolean,
  [BasketActionTypes.SET_ITEM_KL_ELIGIBLE_COLLECTIBLE]: basketItemSetKLEligibleCollectible,
  [BasketActionTypes.SET_KL_ELIGIBLE_COLLECTIBLE]: basketSetKLEligibleCollectible,
  [BasketActionTypes.RESET_KL_ELIGIBLE_COLLECTIBLES]: resetKLEligibleCollectibles,

  [BasketActionTypes.SET_ITEM_IS_GR_ACTIVE]: basketItemSetIsGRActive,
  [BasketActionTypes.SET_IS_GR_ACTIVE]: basketSetIsGRActive,
  [BasketActionTypes.RESET_ALL_GR_ACTIVES]: resetAllGRActives,

  [BasketActionTypes.SET_ITEM_IS_MP_ACTIVE]: basketItemSetIsMPActive,
  [BasketActionTypes.SET_IS_MP_ACTIVE]: basketSetIsMPActive,
  [BasketActionTypes.SET_ITEM_MP_CARD]: basketItemSetMPCard,
  [BasketActionTypes.DEL_ITEM_MP_CARD]: basketItemDelMPCard,
  [BasketActionTypes.SET_MP_CARD]: basketSetMPCard,
  [BasketActionTypes.DEL_MP_CARD]: basketDelMPCard,
  [BasketActionTypes.RESET_ALL_MP_ACTIVES]: resetAllMPActives,
  [BasketActionTypes.RECOMPUTE_NEXT_MP_BASKET_STATE]: recomputeNextMPBasketState,
  [BasketActionTypes.RECOMPUTE_NEXT_GR_BASKET_STATE]: recomputeNextGRBasketState,

  [BetBuilderActionTypes.BASKET_UPDATE_BETBUILDER_ODD]: basketUpdateBetbuilderOdd,

  [MyMatchActionTypes.MERGE]: basketMyMatchMerge,
  [MyMatchActionTypes.SPLIT]: basketSplitMyMatch,
  [MyMatchActionTypes.INJECT_TOP_MY_MATCH_INTO_BASKET]: basketInjectTopMyMatch,
  [BasketActionTypes.UPDATE_ITEM_IS_FROM_MULTICHOICE]: basketUpdateItemIsFromMultichoice,
  [MyMatchActionTypes.REMOVE_MULTICHOICE_BET_SELECTION]: basketRemoveMultichoiceBetSelection,
  [BasketActionTypes.UPDATE_ITEM_VALUE]: basketUpdateItemValue,
  [BasketActionTypes.SANITIZE]: basketSanitize,

  [BasketActionTypes.SET_BOOM_IS_ACTIVE]: basketSetBoomActive,
  [BasketActionTypes.SET_ITEM_BOOM_IS_ACTIVE]: basketItemSetBoomActive,
  [BasketActionTypes.RESET_BOOM_IS_ACTIVES]: basketResetBoomActives,
};

const unSafeHandlersDecorator = [
  cannotTouchBetslip,
  cannotTouchACashoutItem,
  keepBetslipModeSafe,
  removeCashoutProperties,
  loadingSafetyDecorator,
  dontTouchWhilePending,
];

export default {
  ...reduce(
    unSafeHandlers,
    (finalHandlers, handler, action) => ({
      ...finalHandlers,
      [action]: unSafeHandlersDecorator.reduce((composed, f) => f(composed), handler),
    }),
    {},
  ),
  ...safeHandlers,
};
